import { SettingsLabel } from 'apps/studio/components/shared/inputs/SettingsLabel'
import {
    DecimalPlaces,
    DisabledDecimalPlaces,
    StandardAdvancedSettings,
    AdvancedSettingsPanel
} from 'apps/studio/components/settings/fields/Base/advanced'

export const AdvancedPanel = AdvancedSettingsPanel([
    SettingsLabel('Config'),
    DecimalPlaces,
    ...StandardAdvancedSettings
])

export const CurrencyAdvancedPanel = AdvancedSettingsPanel([
    SettingsLabel('Config'),
    DisabledDecimalPlaces,
    ...StandardAdvancedSettings
])
